import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import {
  getClientCreditSummary,
  getCustomersWithCreditBalance,
  getCreditSpendHistory
} from '../requests/credit.request';
import { CreditSpendHistoryParams } from '../types/credit.types';

export const useClientCreditSummaryQuery = (clientId: string, enabled = true) => {
  return useQuery({
    queryKey: ['client-credit-summary', clientId],
    queryFn: async () => await getClientCreditSummary(clientId),
    enabled: enabled && !!clientId,
    onError: () => {
      toast.error("Couldn't fetch client credit summary", { id: 'credit-summary-error' });
    }
  });
};

export const useCustomersWithCreditBalanceQuery = (enabled = true) => {
  return useQuery({
    queryKey: ['customers-with-credit-balance'],
    queryFn: async () => await getCustomersWithCreditBalance(),
    enabled,
    onError: () => {
      toast.error("Couldn't fetch customers with credit balances", {
        id: 'customers-credit-error'
      });
    }
  });
};

export const useCreditSpendHistoryQuery = (
  params: CreditSpendHistoryParams = {},
  enabled = true
) => {
  return useQuery({
    queryKey: ['credit-spend-history', params],
    queryFn: async () => await getCreditSpendHistory(params),
    enabled,
    onError: () => {
      toast.error("Couldn't fetch credit spend history", { id: 'spend-history-error' });
    }
  });
};
